import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#3366FF',
        },
        secondary: {
            main: '#D7D7D7',
        },
    },
    components: {
        MuiTab: {
            styleOverrides: {
                root:{
                    minWidth: '160px'
                },
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root:{
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                },
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    minWidth: '75%',
                    maxWidth: '75%',
                },
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                content: {
                    alignItems: 'center',
                },
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    marginRight: '10px',
                },
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    width: '100%',
                },
            }
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    backgroundColor: 'white',
                },
            }
        },
        MuiButton: {
            styleOverrides: {
                contained: {
                    minWidth: '100px',
                    color: '#FFFFFF',
                    backgroundColor: '#3366FF',
                    boxShadow: '0px 0px 12px #3366FF',
                    borderRadius: '4px',
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    padding: '6px 16px',
                    opacity: '1',
                    '&:hover': {
                        backgroundColor: '#2265AB',
                    },
                    margin: '10px 3px 10px 5px',
                    height: '46px',
                },
                containedSecondary:{
                    color: '#000'
                }
            }
        },
    },
});

export default theme;
